/* eslint-disable import/no-unresolved */
import { Col, Radio as RadioComponent, Row } from 'antd';
import styled, { css } from 'styled-components';
import { truncate } from 'styles/mixins';

export const ProductCardListComponent = styled(Row)`
  padding: 8px 32px 8px 32px;
  background: #fff;

  @media (max-width: 991px) {
    padding: 12px 16px;
    row-gap: 8px;
  }
`;

export const ProductCardComponentImage = styled(Col)`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  width: 100%;

  > div {
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: center;

    .image-gallery {
      width: 100%;
      
      img {
        padding: 8px;
      }
    }

    .arrow-button {
      width: 24px;
      height: 24px;
      

      svg {
        font-size: 12px;
      }
    }
  }
  .image-info {
    font-size: 12px;
    line-height: 12px;
    white-space: nowrap;
  }

  @media (max-width: 991px) {
    flex: 0 0 100% !important;
    max-width: 100% !important;
    margin-bottom: 8px;
  }
`;
export const ProductCardCheck = styled(Col)`
  display: flex;
  justify-content: flex-start;
  align-items: center;

  @media (max-width: 991px) {
    flex: 0 0 100% !important;
    max-width: 100% !important;
    margin-bottom: 4px;
  }
`;

export const ProductCardButtonDelete = styled(Col)`
  display: flex;
  justify-content: flex-end;
  align-items: center;

  @media (max-width: 991px) {
    flex: 0 0 100% !important;
    max-width: 100% !important;
    margin-top: 8px;
  }
`;

export const ProductCardComponentDetails = styled(Col)`
  .icon-information {
    color: #f78e1e;
  }

  padding: 21px 32px;

  .row-details {
    margin-top: 8px;
    height: 100%;
  }

  .col-details-color {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    margin-left: auto;

    p {
      font-weight: 400;
      font-size: 12px;
      line-height: 12px;
      color: #353839;

      span {
        font-weight: 500;
        font-size: 14px;
        line-height: 14px;
      }

      .producer-name {
        color: #f78e1e;
      }
    }
  }

  @media (max-width: 992px) {
    margin-bottom: 60px;
  }

  @media (max-width: 991px) {
    flex: 0 0 100% !important;
    max-width: 100% !important;
    padding: 8px 8px;
    margin-bottom: 0;

    /* tablet: 3 campos por linha */
    .row-details > .ant-col {
      flex: 0 0 33.333%;
      max-width: 33.333%;
      margin-bottom: 12px;
    }

    .col-details-color {
      margin-top: 0;
      margin-left: 0;
      text-align: left !important;
    }
  }

  /* celular: 2 campos por linha */
  @media (max-width: 575px) {
    .row-details > .ant-col {
      flex: 0 0 50%;
      max-width: 50%;
    }
  }
`;

export const ProductCardComponentActions = styled(Col)`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;

  @media (max-width: 991px) {
    flex: 0 0 100% !important;
    max-width: 100% !important;
    width: 100%;
  }

  .line-actions,
  .line-actions-input {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .line-actions {
    justify-content: flex-end;
  }

  .line-actions-quantity {
    display: flex;
    justify-content: flex-end;
  }

  .line-actions-input {
    justify-content: space-between;
    .button-cart {
      margin-right: 8px;
    }
  }

  .line-actions {
    .value-product {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      h1 {
        padding: 0;
        margin: 0 0 4px 0;
      }
    }
    justify-content: flex-end !important;
    flex-wrap: wrap;
  }

  @media (max-width: 992px) {
    .line-actions {
      justify-content: center;
    }
  }

  @media (max-width: 992px) {
    .line-actions-quantity {
      justify-content: center;
    }
  }

  @media (max-width: 991px) {
    .line-actions-quantity {
      flex-wrap: wrap;
      display: flex;
      align-items: center;
      margin-top: 12px;
      margin-bottom: 12px;
      justify-content: center;
    }
  }

  .line-actions-input {
    .button-cart {
      margin-right: 8px;
    }
    @media (max-width: 991px) {
      flex-wrap: wrap;
      display: flex;
      align-items: center;
      justify-content: center;

      .input-quantity {
        margin-bottom: 8px;
      }
    }
  }
`;

export const ShippingFeeValue = styled.span`
  b {
    color: #f78e1e;
  }
`

export const ProductInfo = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 1rem;

  .icon {
    color: #f78e1e;
  }

  .group-information {
    display: block;
    flex: 1;
    min-width: 0;

    .title{
      margin: 0;
      padding: 0;
      font-weight: 400;
      font-size: 12px;
      line-height: 12px;
      color: #353839;
    }

    span {
      font-weight: 500;
      font-size: 12px;
      line-height: 12px;
      color: #353839;
    }

    .package-select {
      width: 100%;
      max-width: 100%;

      .ant-select-selector {
        padding: 0 !important;
      }

      .ant-select-selection-item {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
`
export const ProductNameType = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  .remove-display-calendar {
    margin-left: auto;

    > span > span {
      display: none;
    }
  }

  .name-product {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 0.25rem;
    margin-right: 2rem;
    flex: 1;
    min-width: 0;
    max-width: 100%;
    min-height: 56px;

    > span {
      font-weight: 500;
      font-size: 18px;
      line-height: 18px;
      color: #353839;
      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    > span.concept-name {
      font-weight: 700;
      text-transform: uppercase;
      color: #353839;
      ${truncate()}
    }
  }

  .code-product {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 16px;
    margin-right: 2rem;
    white-space: nowrap;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    color: #8c8c8c;

    .number-product {
      font-weight: 500;
      color: #353839;
    }
  }

  @media (max-width: 991px) {
    justify-content: center;
    .name-product {
      padding: 12px 0;
    }
  }
`;

export const ValueProduct = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 16px;

  .value-per-unity {
    margin-top: 4px;
  }

  span {
    font-weight: 400;
    font-size: 12px;
    line-height: 12px;
    color: #8c8c8c;
  }

  span.value {
    font-weight: 700;
    font-size: 20px;
    line-height: 22px;
  }

  span.currency,
  span.value {
    color: #f78e1e;
  }
`;

export const GroupTypeSaleProduct = styled.div`
  display: flex;
  justify-content: space-between;

  @media (max-width: 991px) {
    justify-content: center;

    .button-type-sale {
      padding: 0 10px !important;
    }
  }

  .button-type-sale {
    display: flex;
    flex-direction: column;
    height: 32px;
    padding: 0 16px;
    align-items: center;
    justify-content: center;
    
    span.title {
      font-size: 12px;
    }

    span {
      font-weight: 400;
      font-size: 12px;
      line-height: 12px;
      color: #353839;
    }

    span.value > span {
      font-size: 14px;
      line-height: 18px;
      color: #f78e1e;
    }

    &.focus {
      background-color: #f78e1e;
      border-color: #f78e1e;

      span > span,
      span {
        color: #fff;
      }
    }
  }

  .no-border-left {
    border-left: none;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  .no-border-right {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-right: none;
  }
`;

export const MinQuantityProduct = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 12px;
  color: #353839;

  > span {
    color: #8c8c8c;
  }
`;

export const AvailableQuantity = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #353839;

  .calc-available {
    color: #8c8c8c;
  }
`;

type ICheckBoxButtonProps = {
  isDisabled?: boolean;
};

export const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: 4px;

  @media (max-width: 575px) {
    justify-content: flex-start;
    gap: 4px;
    flex-wrap: wrap;
  }
`;

export const CheckBoxButton = styled.div<ICheckBoxButtonProps>`
  display: flex;
  align-items: center;

  .ant-radio-inner {
    border-color: black !important;
  }

  .ant-radio-checked .ant-radio-inner:after {
    background-color: #f78e1e !important;
    border-color: #f78e1e !important;
  }

  .ant-radio-wrapper-checked .ant-radio-inner {
    border-color: #f78e1e !important;
  }

  ${({ isDisabled }: ICheckBoxButtonProps) =>
    isDisabled &&
    css`
      cursor: not-allowed;
      opacity: 0.5;
    `}
`;

export const CompositionRadio = styled(RadioComponent)`
  font-size: 0.625rem;

  span {
    padding-right: 0;
  }
`;

export const SaleTypePriceContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: 0.75rem;
  color: black;
  line-height: 1.4;
`;

export const SaleTypePrice = styled.div<{ checked?: boolean }>`
  font-weight: 700;
  font-size: 14px;
  color: ${({ checked }) => (checked ? '#f78e1e' : 'black')};
`;

export const SaleTypeDivider = styled.div`
  border-right: 1px solid #d9d9d9;
  height: 100%;
  min-height: 32px;
  margin: 0 8px;
`;

export const InfoFirstRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  font-size: 12px;
  color: #595959;
  margin-top: 8px;
`;

export const ShippingFeeInline = styled.div`
  font-weight: 700;
  font-size: 11px;
  color: #f78e1e;
  background-color: #fff9eb;
  padding: 2px 4px;
  width: fit-content;
`;
